import type { LatLng } from '../types'

/**
 * 
 * Takes an array of indices and a location stream (array of LatLng)
 * Returns an array of LatLng corresponding to the provided indices
 */
export const getSplitMarkerLocationsFromIndices = (indices: number[], locationStream: LatLng[]): LatLng[] => {
  return indices.map((index: number) => locationStream[index]);
};

export default getSplitMarkerLocationsFromIndices;